import React, {Component} from 'react';
import {Switch, Route,withRouter, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { CSSTransition, TransitionGroup, CSSTransitionGroup } from 'react-transition-group';
import InputMask from "react-input-mask";

import { sendPostRequest } from "./../../APP/HELPERS/requests"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import ScrollPreview from './../../APP/COMPONENTS/ContentParts/ScrollPreview'
import CatPreview from './../../APP/COMPONENTS/ContentParts/CatPreview'
import Adverts from './../../APP/COMPONENTS/ContentParts/Adverts'

import ModalsContainer from './../../APP/MODALS/ModalsContainer.js';

import FooterBlock from './../../APP/COMPONENTS/Footer.js';
import ProductsScrollPreview from './../../APP/COMPONENTS/ContentParts/ProductsScrollPreview';

function mapStateToProps(state, myProps) {
    return {
        DO_SEARCH: state.DO_SEARCH,
        PRODUCTS: state.PRODUCTS,
        POPULAR: state.POPULAR,
        TOKEN: state.TOKEN
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class HomePage extends Component {

	constructor(props)
    {
        super(props);
        this.state = {
            PRODUCTS: props.PRODUCTS,
            PHONE: '+7-___-___-__-__',
            NAME: '',
            EMAIL: ''
        }
    }

    componentDidMount()
    {
        this.props.closeAllModals();
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.DO_SEARCH !== prevProps.DO_SEARCH) {
            if (this.props.DO_SEARCH) {
                this.props.history.push('/search/' + this.props.DO_SEARCH);
            }
        }
        if (this.props.PRODUCTS !== prevProps.PRODUCTS) {
            this.setState({PRODUCTS: true});
        }
    }

    checkUpdates()
    {
        if (this.state.PRODUCTS !== this.props.PRODUCTS) {
            if (!this.state.PRODUCTS) {
                this.setState({UPDATED: true});
            }
        }
    }

    renderAdvert()
    {
        return <Adverts />;
    }

    scrollToForm = () =>
    {
        document.querySelector('#work_form').scrollIntoView({behavior: "smooth"});
    }

    renderFirstLine = () =>
    {
        return (
            <div className="main_first_line">
                <div className="main_first_triangle"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <img src="/system_images/real_bread.jpg" alt="Мы печём настоящий хлеб" />
                        </div>
                        <div className="col-6">
                            <div className="main_h1_holder">
                                <h1 className="main_h1">
                                    Мы печём настоящий хлеб
                                </h1>
                                <div className="main_h1_after">
                                    Свежий хлеб и выпечка местного производства. Весь хлеб, который мы выпекаем, производится из местных продуктов, мы используем самые свежие органические ингредиенты.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCatPreview = () =>
    {
        let CAT = {id: 0, title: 'Популярное', url: 'popular'};
        let products = this.props.POPULAR;

        return (
            <div className="main_cat_preview">
                <div className="main_cat_tr_top"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="main_cat_head">
                                Каталог
                            </div>
                            <ProductsScrollPreview CAT={CAT} IDS={products} />
                        </div>
                    </div>
                </div>
                <div className="main_cat_tr_bottom"></div>
            </div>
        );
    }

    renderLKIntro = () =>
    {
        return (
            <div className="main_lk_intro">
                <div className="container">
                        <div className="row">
                            <div className="col-5">
                            </div>
                            <div className="col-7">
                                <div className="main_lk_head">
                                    Мы рады<br/>новым клиентам!
                                </div>
                                <div className="main_lk_text">
                                    Зарегистрируйтесь<br/>и совершайте покупки!
                                </div>
                                <Link to="/personal" className="main_lk_link">
                                    Перейти к личному кабинету
                                </Link>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }

    doSubmit = async () =>
    {
        try {
            let SEND_DATA = {
                action:     'recordRequest',
                token:      this.props.TOKEN,
                phone:      this.state.PHONE,
                email:      this.state.EMAIL,
                name:       this.state.NAME
            };

            let data = await sendPostRequest(SEND_DATA,CONFIG.API_GATE);
            if (data !== false) {
                this.setState({SUCCESS: true, NAME: '', PHONE: '', EMAIL: '', COMPANY: ''})
            }
        } catch (error) {
        }
    }

    recordPhone = (phone) => 
    {
        this.setState({PHONE: phone.target.value});
    }

    recordEmail = (email) => 
    {
        this.setState({EMAIL: email.target.value});
    }

    recordName = (name) => 
    {
        this.setState({NAME: name.target.value});
    }

    validateEmail = (email) =>
    {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    getSubmitButton()
    {
        if (this.state.SUCCESS) {
            return (
                <div className="work_success">
                    Ваш запрос успешно отправлен! Наш менеджер свяжется с Вами в ближайшее время!
                </div>
            )
        } else {
            let phoneNumber = this.state.PHONE.toString().replace(/\D+/g, '');

            if (((phoneNumber.length == 11) || (this.validateEmail(this.state.EMAIL))) && (this.state.NAME.length > 1)) {
                return (
                    <a className="work_form_button" onClick={() => this.doSubmit()}>
                        Отправить
                    </a>
                );
            } else {
                return (
                    <a className="work_form_button inactive-btn">
                        Отправить
                    </a>
                );
            }
        }
        
    }

    renderWorkForm = () =>
    {
        return (
            <div id="work_form" className="work_form">
                <div className="work_form_top"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <div className="work_head">
                                Хотите сотрудничать?
                            </div>
                            <div className="work_text">
                                Оставьте краткую информацию о себе,<br/>и мы вскоре свяжемся с вами
                            </div>
                            <div className="work_form_form">
                                <input placeholder="Имя" type="text" onChange={(text) => this.recordName(text)} />
                                <InputMask placeholder="Номер телефона" type="tel" mask="+7-999-999-99-99" onChange={(text) => this.recordPhone(text)} />
                                <input placeholder="Или электронная почта" type="email" onChange={(text) => this.recordEmail(text)} />
                                {this.getSubmitButton()}
                            </div>
                            
                        </div>
                        <div className="col-6">
                            <img src="/system_images/bread2.jpg" alt="Хотите сотрудничать?" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderBottom = () =>
    {
        return (
            <div className="main_bottom">
                <img className="curve1" src="/system_images/curve1.png" />
                <img className="curve2" src="/system_images/curve2.png" />
                <h1 className="main_h1">О нас</h1>
                <div className="main_text">
                    Мы акцентируем своё внимание на производстве различных кондитерских и хлебобулочных изделий высокого качества из отобранных профессионалами экологически безопасных ингредиентов натурального происхождения. Ручной труд мастеров, делает каждую булочку, каждый продукт уникальным и вкусным.
                </div>
                <Link to="/company/info">
                    Подробнее
                </Link>
            </div>
        )
    }

	render() {
        if (!this.state.PRODUCTS) {
            return false;
        }
        
    	return (
            <CSSTransitionGroup
                transitionAppear={true}
                transitionAppearTimeout={600}
                transitionEnterTimeout={600}
                transitionLeaveTimeout={200}
                transitionName={'SlideIn'}
            > 
                <Helmet>
                    <title>Настоящий Хлеб - Пекарня в Москве для частных лиц и опта</title>
                    <meta name="description" content="Настоящий Хлеб - Пекарня в Москве для частных лиц и опта. Высокое качество, уникальные рецепты" />
                    <meta name="keywords" content="Настоящий Хлеб - Пекарня в Москве для частных лиц и опта" />
                </Helmet>
                {this.renderAdvert()}
                <ScrollPreview ID={-3} />
                <ScrollPreview ID={-1} />
                
                <CatPreview />
                <ScrollPreview ID={-2} />
                {/*}
                        <div className="main_page_intro">
                            <a className="intro_to_form" onClick={() => this.scrollToForm()}>
                                Хотите с нами<br/>сотрудничать?
                            </a>
                        </div>
                        {this.renderFirstLine()}
                        {this.renderCatPreview()}
                        {this.renderLKIntro()}
                        {this.renderWorkForm()}
                */}
                {this.renderBottom()}
                <ModalsContainer />
            </CSSTransitionGroup> 
		);
	}

}

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(HomePage))
